module.exports = __webpack_public_path__ + "static/media/bacahau2075.931860bd.webp";